import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import styled from 'styled-components';

const StyledPaper = styled(Paper)`
  padding: 20px;
  width: calc(100% - 20px);
  max-width: 600px;
  margin: 15px auto;
`;

const StyledTypography = styled(Typography)`
  && {
    font-size: 15px;
  }
`;

const textVariations = {
  'forgot-password':
    'We just sent you an email with the instructions to reset your password.',
  registration:
    'Your account was successfully created. Feel free to sign in now.'
};

const getPageText = (params = {}) => {
  const { page } = params;
  if (textVariations[page]) {
    return textVariations[page];
  }
  return 'Page not found';
};

const SuccessPage = ({ match }) => (
  <StyledPaper>
    <StyledTypography>{getPageText(match.params)}</StyledTypography>
  </StyledPaper>
);

export default SuccessPage;
